import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Home from './pages/index';
import About from './pages/about';
import Contact from './pages/contact';
import Service from './pages/service';
import Policy  from './pages/policy';
import Terms from './pages/terms'


function Routers () {
    return (
      <Router>
           <Routes>
                  <Route path="/" exact element={<Home/>}/>
                  <Route path="/mystra-about" exact element={<About/>}/>
                  <Route path="/mystra-contact" exact element={<Contact/>}/>
                  <Route path="/mystra-service" exact element={<Service/>}/>
                  {/* <Route path="/mystra-team" exact element={<Team/>}/> */}
                    <Route path="/mystra-terms-of-service" exact element={<Terms/>}/>
                    <Route path="/mystra-privacy-policy" exact element={<Policy/>}/>
             </Routes>
       </Router>
      )
}
export default Routers;